module.exports = __webpack_public_path__ + "img/grafana.c50c0339.svg";